import { useCallback, useMemo } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service';
import { performPostRequest } from '@atlassian/jira-fetch';
import type { SendToMailRequestObject } from '../types';
import { buildPostSendMailToAdmin } from '../utils';

export const useSendMailToAdmin = () => {
	const request = useCallback(
		(options: SendToMailRequestObject) =>
			performPostRequest(buildPostSendMailToAdmin(), {
				body: JSON.stringify(options),
			}),
		[],
	);
	const { loading, error, data, fetch } = useService<undefined, SendToMailRequestObject>(request);
	const memoisedData = useMemo(() => data, [data]);
	return {
		loading,
		error,
		data: memoisedData,
		sendMailToAdmin: fetch,
	};
};
